import api from '../lib/api';
import type { CatalogItem, CatalogFile, CatalogItemInput, PaginatedResponse } from '../types/catalog';

export interface GetItemsParams {
  page?: number;
  limit?: number;
  type?: string;
  search?: string;
}

class CatalogService {
  async getItems(params?: GetItemsParams): Promise<PaginatedResponse<CatalogItem>> {
    const response = await api.get('/catalog/items', { params });
    return response.data;
  }

  async getItem(id: number): Promise<CatalogItem> {
    const response = await api.get(`/catalog/items/${id}`);
    return response.data.data;
  }

  async createItem(data: CatalogItemInput): Promise<CatalogItem> {
    const response = await api.post('/catalog/items', data);
    return response.data.data;
  }

  async updateItem(id: number, data: CatalogItemInput): Promise<CatalogItem> {
    const response = await api.put(`/catalog/items/${id}`, data);
    return response.data.data;
  }

  async deleteItem(id: number): Promise<void> {
    await api.delete(`/catalog/items/${id}`);
  }

  async uploadFile(itemId: number, file: File): Promise<CatalogFile> {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post(`/catalog/items/${itemId}/files`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data.data;
  }

  async getFiles(itemId: number): Promise<CatalogFile[]> {
    const response = await api.get(`/catalog/items/${itemId}/files`);
    return response.data.data;
  }

  async deleteFile(itemId: number, fileId: number): Promise<void> {
    await api.delete(`/catalog/items/${itemId}/files/${fileId}`);
  }
}

export default new CatalogService();